import React from 'react';
import { withTranslation } from 'react-i18next';

import FiltersActions from '../../../../actions/FiltersActions';

import FiltersConstants from '../../../../constants/FiltersConstants';
import Analytics from 'arbitrip-common/client/analytics';

import FilterCheckboxWithLabel from './components/FilterCheckboxWithLabel.react';
import SearchActions from '../../../../actions/SearchActions';

class AmenitiesFilter extends React.Component {
	constructor(props) {
		super(props);

		this.handleResetAmenitiesClick = this.handleResetAmenitiesClick.bind(this);
		this.handleCheckboxChangeByAmenity = this.handleCheckboxChangeByAmenity.bind(this);
		this.handleAmenityOnlyClick = this.handleAmenityOnlyClick.bind(this);
		this.executeFilter = this.executeFilter.bind(this);
	}

	handleCheckboxChangeByAmenity(event, isInputChecked, amenity) {
		const { profile, t } = this.props;

		event.persist();

		this.executeFilter(FiltersActions.filterByAmenity, amenity, isInputChecked);

		const filter_value = t(isInputChecked ? 'FilterByAmenity' : 'DontFilterByAmenity', { amenity });
		Analytics.actions.interactions.filteredResults(profile, FiltersConstants.FILTER_METHOD.AMENITIES, filter_value);
	}

	executeFilter(filterFunction, amenity, isInputChecked) {
		filterFunction(amenity, isInputChecked);
		setTimeout(function () {
			SearchActions.executeFilterSearch();
		}, 10);
		setTimeout(() => {
			filterFunction(amenity, isInputChecked);
		}, 500);
	}

	handleAmenityOnlyClick(e) {
		const { profile, t } = this.props;

		e.persist();
		var filter_amenity_only = e.target.getAttribute('data-amenity');
		this.executeFilter(FiltersActions.filterByAmenityOnly, filter_amenity_only);

		var filter_value = t('ShowOnlyAmenity', { amenity: filter_amenity_only });
		Analytics.actions.interactions.filteredResults(
			profile,
			FiltersConstants.FILTER_METHOD.AMENITY_ONLY,
			filter_value,
		);
	}

	handleResetAmenitiesClick(e) {
		const { profile, t } = this.props;

		e.persist();
		FiltersActions.resetAmenitiesFilter();
		setTimeout(function () {
			FiltersActions.resetAmenitiesFilter();
		}, 10);

		const filter_value = t('ResetAmenitiesFilter');
		Analytics.actions.interactions.filteredResults(
			profile,
			FiltersConstants.FILTER_METHOD.RESET_AMENITIES_FILTER,
			filter_value,
		);
	}

	render() {
		const { t } = this.props;
		const data = this.props.filter;
		const multiple_amenities = Object.keys(data).length > 1;

		const amenities = [
			{
				value: FiltersConstants.AMENITIES.FREE_WIFI,
				label: t('AMENITY_FREE_WIFI'),
			},
			{
				value: FiltersConstants.AMENITIES.PARKING,
				label: t('AMENITY_PARKING'),
			},
			{
				value: FiltersConstants.AMENITIES.AIRPORT_SHUTTLE,
				label: t('AMENITY_AIRPORT_SHUTTLE'),
			},
			{
				value: FiltersConstants.AMENITIES.FITNESS_CENTRE,
				label: t('AMENITY_FITNESS_CENTRE'),
			},
			{
				value: FiltersConstants.AMENITIES.RESTAURANT,
				label: t('AMENITY_RESTAURANT'),
			},
			{
				value: FiltersConstants.AMENITIES.MEETING_ROOM,
				label: t('AMENITY_MEETING_ROOM'),
			},
			{
				value: FiltersConstants.AMENITIES.SWIMMING_POOL,
				label: t('AMENITY_SWIMMING_POOL'),
			},
			{
				value: FiltersConstants.AMENITIES.AIR_CONDITIONING,
				label: t('AMENITY_AIR_CONDITIONING'),
			},
			{
				value: FiltersConstants.AMENITIES.ELECTRIC_VEHICLE_CHARGING_STATION,
				label: t('AMENITY_ELECTRIC_VEHICLE_CHARGING_STATION'),
			},
			{
				value: FiltersConstants.AMENITIES.ACCESSIBILITY,
				label: t('AMENITY_ACCESSIBILITY'),
			},
			{
				value: FiltersConstants.AMENITIES.PETS_ALLOWED,
				label: t('AMENITY_PETS_ALLOWED'),
			},
		];

		const AMENITIES = amenities.map((amenity) => (
			<div className="checkbox-container" key={amenity.value}>
				<FilterCheckboxWithLabel
					checked={data[amenity.value]}
					category={amenity.value}
					label={amenity.label}
					onChange={(e, c, amenity) => this.handleCheckboxChangeByAmenity(e, c, amenity)}
				/>

				{multiple_amenities ? (
					<button
						className="btn btn-link"
						data-amenity={amenity.value}
						onClick={this.handleAmenityOnlyClick}
						aria-label={t('SelectOnly', { category: amenity.label })}
					>
						{t('Only')}
					</button>
				) : null}
			</div>
		));

		return (
			<div className="filter disabled" data-testid="filter-amenities">
				<label className="filter-title" htmlFor="amenities-filter">
					{t('Amenities')}
				</label>
				<div name="amenities-filter" className="check-list" aria-label={t('Amenities')}>
					{AMENITIES}
				</div>
				{AMENITIES.length > 1 ? (
					<button
						className="clear-button-wrap"
						onClick={this.handleResetAmenitiesClick}
						aria-label={t('ResetAmenities')}
					>
						<div className="clear-button-img" />
					</button>
				) : null}
			</div>
		);
	}
}

export default withTranslation()(AmenitiesFilter);
